<div class="overlay-medium">
  <app-card-medium title="{{ 'Upload Files' | translate }}">
    <div class="content">
      <app-file-upload (onSelected)="onFileSelected($event)"></app-file-upload>
      <ng-container *ngIf="ui?.selectedFiles?.length">
        <!-- Text and progress bar area -->
        <ng-container *ngIf="ui?.uploading && ui?.progress !== 100">
          <div class="progress mt-3">
            <div class="progress-bar" role="progressbar" aria-valuenow="0" aria-valuemin="0" aria-valuemax="100"
              [ngStyle]="{'width': ui.progress}">
            </div>
          </div>
        </ng-container>
        <ng-container *ngIf="!ui?.uploading && ui?.progress === 100">
          <div class="mt-3" style="display: flex; justify-content: center;">
            <span>{{ui.selectedFiles.length}} {{'file(s) have been uploaded' | translate }}</span>
          </div>
        </ng-container>
        <ng-container *ngIf="!ui?.uploading && !ui?.progress">
          <div class="mt-3" style="display: flex; justify-content: center;">
            <span>{{ui.selectedFiles.length}} {{'file(s) are selected for upload' | translate }}</span>
          </div>
        </ng-container>

        <!-- Buttons area -->
        <ng-container *ngIf="!ui?.uploading && ui?.progress === 100">
          <div class="mt-2" style="display: flex; justify-content: flex-end;">
            <div (click)="onCancelClicked()" class="btn btn-sm btn-secondary">{{'Done' | translate}}</div>
          </div>
        </ng-container>
        <ng-container *ngIf="!ui?.uploading && ui?.progress !== 100">
          <div class="mt-2" style="display: flex; justify-content: space-between;">
            <div (click)="onCancelClicked()" [ngClass]="{'disabled': ui.uploading}" class="btn btn-sm btn-light">
              {{'Cancel' | translate}}</div>
            <div (click)="onUploadClicked()" [ngClass]="{'disabled': ui.uploading}" class="btn btn-sm btn-primary">
              {{'Upload' | translate}}</div>
          </div>
        </ng-container>
      </ng-container>
    </div>
  </app-card-medium>
</div>